export default function formatAdSizeFromString(adSizeString: string) {
  try {
    if (adSizeString === 'All') return {width: 0, height: 0};

    const [width, height] = adSizeString.split('x').map(Number);

    return {width, height};
  } catch (_) {
    return null;
  }
}
